<template>
	<div>
		<div class="card">
			<header class="card-header">
				<h3 class="card-title">Youtube Video Settings</h3>
			</header>
			<div class="card-body">
				<div>
					<label>Text:</label>
					<p>{{ reviewContent.translations[clickedLang].video_text }}</p>
				</div>
				<div>
					<label>ID:</label>
					<p>{{ reviewContent.translations[clickedLang].video_id }}</p>
				</div>
				<a @click="showEditModal()" class="btn btn-icon btn-primary" href="#" title="Comment Edit">Edit/Add Video</a>
			</div>
		</div>

		<modal @close="closeEditModal" v-show="isEditModalVisible">
			<template slot="header">
				<h4 class="modal-title">Video Settings</h4>
			</template>
			<template slot="body">
				<div class="form-group">
					<label for="video_text">Video text</label>
					<textarea id="video_text" v-model="reviewContent.translations[clickedLang].video_text"></textarea>
				</div>
				<div class="form-group">
					<label for="video_id">Youtube ID</label>
					<input id="video_id" v-model="reviewContent.translations[clickedLang].video_id" type="text">
				</div>
			</template>
			<template slot="footer">
				<a @click.prevent="closeEditModal" aria-label="Close modal" class="btn btn-md btn-primary modal-close" href="#"><i class="fas fa-times"></i> Cancel</a>
				<a @click.prevent="saveVideoSettings" class="btn btn-md btn-success"><i class="fas fa-save"></i> Save Changes</a>
			</template>
		</modal>
	</div>
</template>

<script>
	import modal from '../../Modal/DefaultModal.vue';
	import {eventBus} from "../../../app";

	export default {
		components: {
			modal
		},
		props: {
			editorContent: {
				reviewContent: {}
			},
			providerId: {
				type: Number
			}
		},
		data() {
			return {
				reviewContent: this.editorContent,
				provider: this.providerId,
				clickedLang: this.$defaultLanguage.locale,

				isEditModalVisible: false
			}
		},
		created() {
			let vm = this;

			// When setActiveStatus method ran, change selected data in form fields
			/* From LangSelector */
			eventBus.$on('setActiveStatus', function (clickedLang) {
				vm.clickedLang = clickedLang;
			});
		},
		methods: {
			showEditModal: function () {
				this.isEditModalVisible = true;
			},
			closeEditModal: function () {
				this.isEditModalVisible = false;
			},
			saveVideoSettings: function () {

				this.$toastr.success('Youtube video field updated', 'Success');
				this.isEditModalVisible = false;
				let videoData = {
					locale: this.clickedLang,
					video_text: this.reviewContent.translations[this.clickedLang].video_text,
					video_id: this.reviewContent.translations[this.clickedLang].video_id
				};
			}
		}
	}
</script>
